module.exports = __webpack_public_path__ + "static/img/letterheadkpdn.369bdef.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/mypetrol/letterheadkpdn.png
// module id = XTJH
// module chunks = 107